import { useHistory, useLocation } from 'react-router-dom';

export type OKRManageViewType = 'list' | 'listWithHierarchy' | 'card' | 'tree';

export const useOKRManageViewType = () => {
  const location = useLocation();
  const { search } = location;
  const history = useHistory();
  const viewTypeFromParam = new URLSearchParams(search).get('manageViewType') as OKRManageViewType;

  const setViewType = (viewType: OKRManageViewType) => {
    const queryParams = new URLSearchParams(search);
    queryParams.set('manageViewType', viewType);
    history.push({
      search: queryParams.toString(),
    });
  };

  const replaceViewType = (viewType: OKRManageViewType) => {
    const queryParams = new URLSearchParams(search);
    queryParams.set('manageViewType', viewType);
    history.replace({
      search: queryParams.toString(),
    });
  };

  return {
    viewType: viewTypeFromParam,
    setViewType,
    replaceViewType,
  };
};
